import { Setting, SettingPutRequest } from "callable-data-objects";
import { useAccount } from "Hooks/Endpoints";
import { APIAccountSettingContext } from "Providers/APIContexts";
import React, { useEffect, useState } from "react";
import { DefaultProviderProps } from "./types";

const APISettingProvider = ({ children }: DefaultProviderProps) => {
  const { account, select: selectAccount, settingService } = useAccount();
  const [settings, setSettings] = useState<Setting[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (settingService) {
      settingService.list().then((resp: Setting[]) => {
        setSettings(resp);
      });
    }
  }, [settingService]);

  async function update(id: string, payload: SettingPutRequest) {
    if (account) {
      setLoading(true);
      settingService.put(id, payload).then(() => {
        selectAccount(account.id);
        setLoading(false);
      });
    }
  }

  async function remove(id: string) {
    if (account) {
      setLoading(true);
      settingService.delete(id).then(() => {
        selectAccount(account.id);
        setLoading(false);
      });
    }
  }

  return (
    <APIAccountSettingContext.Provider
      value={{
        account,
        settings,
        update,
        remove,
        loading,
      }}
    >
      {children}
    </APIAccountSettingContext.Provider>
  );
};

export default APISettingProvider;
